import type { DocumentTypeInput, TrailerTypeInput, TruckClassInput } from '@chukua/common';
import { api } from '../../lib/api';

export interface TruckClass {
  id: string;
  code: string;
  name: string;
  typicalCapacityTonnes: number;
  isActive: boolean;
}

export interface TrailerType {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
}

export interface DocumentType {
  id: string;
  code: string;
  name: string;
  appliesTo: 'truck' | 'trailer' | 'driver';
  legalHardBlock: boolean;
  crossBorderOnly: boolean;
  typicalValidityDays: number;
  reminderLeadDays: number;
  isActive: boolean;
}

export function listTruckClasses(): Promise<TruckClass[]> {
  return api<TruckClass[]>('/truck-classes');
}

export function createTruckClass(input: TruckClassInput): Promise<TruckClass> {
  return api<TruckClass>('/truck-classes', { method: 'POST', body: JSON.stringify(input) });
}

export function updateTruckClass(id: string, input: TruckClassInput): Promise<TruckClass> {
  return api<TruckClass>(`/truck-classes/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateTruckClass(id: string): Promise<void> {
  await api<void>(`/truck-classes/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateTruckClass(id: string): Promise<void> {
  await api<void>(`/truck-classes/${id}/reactivate`, { method: 'POST' });
}

export function listTrailerTypes(): Promise<TrailerType[]> {
  return api<TrailerType[]>('/trailer-types');
}

export function createTrailerType(input: TrailerTypeInput): Promise<TrailerType> {
  return api<TrailerType>('/trailer-types', { method: 'POST', body: JSON.stringify(input) });
}

export function updateTrailerType(id: string, input: TrailerTypeInput): Promise<TrailerType> {
  return api<TrailerType>(`/trailer-types/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateTrailerType(id: string): Promise<void> {
  await api<void>(`/trailer-types/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateTrailerType(id: string): Promise<void> {
  await api<void>(`/trailer-types/${id}/reactivate`, { method: 'POST' });
}

export function listDocumentTypes(): Promise<DocumentType[]> {
  return api<DocumentType[]>('/document-types');
}

export function createDocumentType(input: DocumentTypeInput): Promise<DocumentType> {
  return api<DocumentType>('/document-types', { method: 'POST', body: JSON.stringify(input) });
}

export function updateDocumentType(id: string, input: DocumentTypeInput): Promise<DocumentType> {
  return api<DocumentType>(`/document-types/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export async function deactivateDocumentType(id: string): Promise<void> {
  await api<void>(`/document-types/${id}/deactivate`, { method: 'POST' });
}

export async function reactivateDocumentType(id: string): Promise<void> {
  await api<void>(`/document-types/${id}/reactivate`, { method: 'POST' });
}
